import { HotelCategoryId } from '../model/types';

const RELATED_HOTEL_CATEGORY_IDS: Partial<Record<HotelCategoryId, readonly HotelCategoryId[]>> = {
  [HotelCategoryId.FiveStars]: [HotelCategoryId.FiveStarsHv1],
  [HotelCategoryId.FourStars]: [HotelCategoryId.FourStarsHv2],
  [HotelCategoryId.TwoStars]: [HotelCategoryId.OneStar],
};

export function getSearchHotelCategoryIds(hotelCategoryIds: readonly number[]): number[] {
  const searchHotelCategoryIds = hotelCategoryIds.flatMap((hotelCategoryId) => [
    hotelCategoryId,
    ...(RELATED_HOTEL_CATEGORY_IDS[hotelCategoryId as HotelCategoryId] ?? []),
  ]);

  return Array.from(new Set(searchHotelCategoryIds));
}
